import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { InputGroup, FormControl } from 'react-bootstrap';

const LabeledCheckbox = ({
	id,
	text,
	value,
	checked,
	onChange,
	disabled,
	textClass
}) => {
	const toggleCheckbox = () => {
		if (disabled) {
			return;
		}
		const clickSimulation = {
			target: {
				value,
				checked: !checked
			}
		};
		onChange(clickSimulation);
	};

	const classNames = classnames('labeledCheckbox', {disabled});
	const inputId = id || `labeled-checkbox-${String(text || 'option').replace(/\s+/g, '-').toLowerCase()}`;

	return (
		<InputGroup className={classNames}>
			<InputGroup.Addon>
				<input
					id={inputId}
					disabled={disabled}
					type="checkbox"
					value={value}
					checked={checked}
					aria-label={text}
					onChange={onChange} />
			</InputGroup.Addon>
			<label htmlFor={inputId} className="sr-only">{text}</label>
			<FormControl
				readOnly
				type="text"
				className={`inputGroupRightText ${textClass || ''}`.trim()}
				onClick={toggleCheckbox}
				value={text}
				aria-hidden="true" />
		</InputGroup>
	);
};

export default LabeledCheckbox;

LabeledCheckbox.propTypes = {
	id: PropTypes.string,
	text: PropTypes.string,
	value: PropTypes.string,
	checked: PropTypes.bool,
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	textClass: PropTypes.string
};